
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/amanaki-thao-dien/rooms/[slug]",
      function () {
        return require("private-next-pages/amanaki-thao-dien/rooms/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/amanaki-thao-dien/rooms/[slug]"])
      });
    }
  